import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, connect } from 'react-redux';
import { signIn, getWorkspaces, getWorkspaceInvites, getUser } from '../../../actions';
import { clearUnauthorized } from '../../../actions/userAction';
import { AuthInput } from '../../../src-new/components/inputs/AuthInput';
import { FormattedMessage, useIntl } from 'react-intl';

const SigninForm = (props) => {
  const { dark } = props;
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const redirectAfterLogin = searchParams.get('redirect');

  const [emailAddress, setEmailAddress] = useState('');
  const [password, setPassword] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    navigate('/signin');
  }, [props.verificationRes, navigate]);

  const submitHandler = async (e) => {
    e.preventDefault();
    setEmailError('');
    setPasswordError('');

    let hasError = false;
    if (!emailAddress) { setEmailError(intl.formatMessage({ id: 'EMAIL_REQUIRED', defaultMessage: 'Email is required' })); hasError = true; }
    if (!password) { setPasswordError(intl.formatMessage({ id: 'PASSWORD_REQUIRED', defaultMessage: 'Password is required' })); hasError = true; }
    if (hasError) return;

    setIsSubmitting(true);
    dispatch(signIn(
      { email: emailAddress, password },
      async () => {
        await dispatch(getWorkspaces('SigninForm'));
        await dispatch(getWorkspaceInvites());
        await dispatch(getUser(localStorage.getItem('Id')));
        dispatch(clearUnauthorized());
        navigate(redirectAfterLogin || '/select-workspace', { replace: true });
      },
      () => {
        setIsSubmitting(false);
        setEmailError(intl.formatMessage({ id: 'USER_NOT_EXIST', defaultMessage: "No account found with this email." }));
      },
      (data) => {
        setIsSubmitting(false);
        if (data?.response?.status === 404) setEmailError(intl.formatMessage({ id: 'USER_NOT_EXIST', defaultMessage: "No account found with this email." }));
        else if (data?.response?.status === 400) setPasswordError(intl.formatMessage({ id: 'PASSWORD_INVALID', defaultMessage: 'Incorrect password. Please try again.' }));
      }
    ));
  };

  return (
    <form onSubmit={submitHandler} noValidate>
      <AuthInput
        label={intl.formatMessage({ id: 'EMAIL', defaultMessage: 'Email' })}
        name="email"
        value={emailAddress}
        onChange={(e) => { setEmailAddress(e.target.value); setEmailError(''); }}
        placeholder="you@company.com"
        error={emailError}
        dark={dark}
      />
      <AuthInput
        label={intl.formatMessage({ id: 'PASSWORD', defaultMessage: 'Password' })}
        isPassword
        type="password"
        name="password"
        value={password}
        onChange={(e) => { setPassword(e.target.value); setPasswordError(''); }}
        placeholder="Enter your password"
        error={passwordError}
        passwordVisible={passwordVisible}
        togglePasswordVisibility={() => setPasswordVisible(v => !v)}
        dark={dark}
      />

      <div className="flex items-center justify-between mt-4">
        <label className="flex items-center gap-2 cursor-pointer select-none">
          <input type="checkbox" className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 focus:ring-offset-0" />
          <span className="text-sm" style={dark ? { color: 'rgba(255,255,255,0.5)' } : { color: '#4b5563' }}>
            <FormattedMessage id="REMEMBER_PASSWORD" defaultMessage="Remember me" />
          </span>
        </label>
        <Link to="/resetpassword" className="text-sm font-medium" style={dark ? { color: 'rgba(147,197,253,0.9)' } : { color: '#2563eb' }}>
          <FormattedMessage id="FORGOTTEN_PASSWORD" defaultMessage="Forgot password?" />
        </Link>
      </div>

      <button
        type="submit"
        disabled={isSubmitting}
        className={`mt-6 w-full py-2.5 px-4 text-white text-sm font-semibold rounded-xl shadow-sm ${dark ? 'auth-btn-primary' : 'bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 transition-colors duration-150'}`}
      >
        {isSubmitting
          ? <span className="flex items-center justify-center gap-2">
              <svg className="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
              </svg>
              Signing in…
            </span>
          : <FormattedMessage id="SIGN_IN" defaultMessage="Sign in" />
        }
      </button>

      <p className="mt-5 text-center text-sm" style={dark ? { color: 'rgba(255,255,255,0.4)' } : { color: '#6b7280' }}>
        <FormattedMessage id="DONT_HAVE_ACCOUNT" defaultMessage="Don't have an account?" />{' '}
        <Link to="/signup" className="font-medium" style={dark ? { color: 'rgba(147,197,253,0.9)' } : { color: '#2563eb' }}>
          <FormattedMessage id="SIGN_UP" defaultMessage="Sign up" />
        </Link>
      </p>
    </form>
  );
};

const mapStateToProp = (state) => ({ verificationRes: state.userReducer.success });
export default connect(mapStateToProp)(SigninForm);
